// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"fb34de75","484":"63ef2c49"}[chunkId] + ".chunk.js";
};